import { render, staticRenderFns } from "./gameRankTable.vue?vue&type=template&id=2b570224"
import script from "./gameRankTable.vue?vue&type=script&lang=js"
export * from "./gameRankTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports